import {
    faClipboardList,
    faEdit,
    faPlus,
    faTrash,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useState } from "react";
import { ColumnDescription } from "react-bootstrap-table-next";
import CadastrarDescontoAlcada from "../../../../Components/CardsPages/CadastrarDescontoAlcada";
import { Spinner } from "../../../../Components/Loding/SpinnerPadrao";
import ModalComponent from "../../../../Components/Modais";
import { IComponentModal } from "../../../../Components/Modais/IModalComponent";
import Table from "../../../../Components/Table";
import {
    ExcluirAlcadaDescontoController,
    ListarAlcadaDescontoPorGrupoController,
} from "../../../../Controllers/Cobranca/AlcadaDesconto/AlcadaDescontoController";
import useAsyncCallback from "../../../../hooks/useAsyncCallback";
import useAsyncEffect from "../../../../hooks/useAsyncEffect";
import { IAlcadaDescontoPorGrupo } from "../../../../Interfaces/Cobranca/AlcadaDesconto/AlcadaDescontoInterface";
import { AlertConfirmation } from "../../../../Tools/SweetAlerts";
import filterFactory, {
    selectFilter,
    textFilter,
} from "react-bootstrap-table2-filter";

interface IDescontoAlcadaProps {}

export default function DescontoAlcadaCobranca(props: IDescontoAlcadaProps) {
    const [show, setShow] = useState(false);
    const [modal, setModal] = useState<IComponentModal>();

    const [filtroIDAlcada, setFiltroIDAlcada] = useState("");
    const [filtroIDEmpresa, setFiltroIDEmpresa] = useState("");
    const [filtroIDObra, setFiltroIDObra] = useState("");
    const [filtroPercentualMulta, setFiltroPercentualMulta] = useState("");
    const [filtroPercentualJuros, setFiltroPercentualJuros] = useState("");
    const [filtroQuantidadeParcelas, setFiltroQuantidadeParcelas] =
        useState("");
    const [filtroInicioAging, setFiltroInicioAging] = useState("");
    const [filtroFimAging, setFiltroFimAging] = useState("");
    const [filtroIDGrupo, setFiltroIDGrupo] = useState("");
    const [filtroGrupo, setFiltroGrupo] = useState("");
    const [flValorPrincipal, setFlValorPrincipal] = useState<
        boolean | undefined
    >(undefined);
    const [percentualValorPrincipal, setPercentualValorPrincipal] =
        useState("");

    const {
        value: alcadasDesconto,
        loading: alcadasDescontoLoading,
        execute: updateList,
    } = useAsyncEffect(
        () =>
            ListarAlcadaDescontoPorGrupoController({
                ID_ALCADA_DESCONTO: filtroIDAlcada ? Number(filtroIDAlcada) : 0,
                ID_EMPRESA: filtroIDEmpresa ? Number(filtroIDEmpresa) : 0,
                ID_OBRA: filtroIDObra ? filtroIDObra : null,
                NUM_PERCENTUAL_MULTA: filtroPercentualMulta
                    ? Number(filtroPercentualMulta)
                    : 0,
                NUM_PERCENTUAL_JUROS: filtroPercentualJuros
                    ? Number(filtroPercentualJuros)
                    : 0,
                NUM_MINIMO_PARCELAS: filtroQuantidadeParcelas
                    ? Number(filtroQuantidadeParcelas)
                    : 0,
                NR_INICIO_AGING: filtroInicioAging
                    ? Number(filtroInicioAging)
                    : 0,
                NR_FIM_AGING: filtroFimAging ? Number(filtroFimAging) : 0,
                ID_GRUPO: filtroIDGrupo ? Number(filtroIDGrupo) : 0,
                DS_GRUPO: filtroGrupo ? filtroGrupo : null,
                FL_VALOR_PRINCIPAL: flValorPrincipal
                    ? flValorPrincipal
                    : undefined ?? false,
                NUM_PERCENTUAL_VALOR_PRINCIPAL: percentualValorPrincipal
                    ? Number(percentualValorPrincipal)
                    : undefined,
            }),
        [
            filtroIDAlcada,
            filtroIDEmpresa,
            filtroIDObra,
            filtroPercentualMulta,
            filtroPercentualJuros,
            filtroQuantidadeParcelas,
            filtroInicioAging,
            filtroFimAging,
            filtroIDGrupo,
            filtroGrupo,
        ]
    );

    const {
        execute: excluirAlcadaDesconto,
        loading: excluirAlcadaDescontoLoading,
    } = useAsyncCallback(ExcluirAlcadaDescontoController);

    const tableviewColumns: Array<ColumnDescription<IAlcadaDescontoPorGrupo>> =
        [
            {
                dataField: "ID_ALCADA_DESCONTO",
                text: "ID Alçada",
                filter: textFilter({
                    placeholder: "Filtro...",
                    onFilter: (filterValue) => {
                        setFiltroIDAlcada(filterValue.toString());
                    },
                }),
            },
            {
                dataField: "ID_EMPRESA",
                text: "ID Empresa",
                filter: textFilter({
                    placeholder: "Filtro...",
                    onFilter: (filterValue) => {
                        setFiltroIDEmpresa(filterValue.toString());
                    },
                }),
            },
            {
                dataField: "ID_OBRA",
                text: "ID Obra",
                filter: textFilter({
                    placeholder: "Filtro...",
                    onFilter: (filterValue) => {
                        setFiltroIDObra(filterValue.toString());
                    },
                }),
            },
            {
                dataField: "NUM_PERCENTUAL_MULTA",
                text: "Percentual de Multa",
                filter: textFilter({
                    placeholder: "Filtro...",
                    onFilter: (filterValue) => {
                        setFiltroPercentualMulta(filterValue.toString());
                    },
                }),
            },
            {
                dataField: "NUM_PERCENTUAL_JUROS",
                text: "Percentual de Juros",
                filter: textFilter({
                    placeholder: "Filtro...",
                    onFilter: (filterValue) => {
                        setFiltroPercentualJuros(filterValue.toString());
                    },
                }),
            },
            {
                dataField: "NUM_MINIMO_PARCELAS",
                text: "Quantidade Minima Parcelas",
                filter: textFilter({
                    placeholder: "Filtro...",
                    onFilter: (filterValue) => {
                        setFiltroQuantidadeParcelas(filterValue.toString());
                    },
                }),
            },
            {
                dataField: "NR_INICIO_AGING",
                text: "Inicio Aging",
                filter: textFilter({
                    placeholder: "Filtro...",
                    onFilter: (filterValue) => {
                        setFiltroInicioAging(filterValue.toString());
                    },
                }),
            },
            {
                dataField: "NR_FIM_AGING",
                text: "Fim Aging",
                filter: textFilter({
                    placeholder: "Filtro...",
                    onFilter: (filterValue) => {
                        setFiltroFimAging(filterValue.toString());
                    },
                }),
            },
            {
                dataField: "ID_GRUPO",
                text: "ID Grupo",
                filter: textFilter({
                    placeholder: "Filtro...",
                    onFilter: (filterValue) => {
                        setFiltroIDGrupo(filterValue.toString());
                    },
                }),
            },
            {
                dataField: "DS_GRUPO",
                text: "Grupo",
                filter: textFilter({
                    placeholder: "Filtro...",
                    onFilter: (filterValue) => {
                        setFiltroGrupo(filterValue.toString());
                    },
                }),
            },
            {
                dataField: "FL_VALOR_PRINCIPAL",
                text: "Valor Principal",
                formatter: (cell) => (cell ? "Sim" : "Não"),
                filter: selectFilter({
                    placeholder: "Filtro...",
                    onFilter: (filterValue) => {
                        setFlValorPrincipal(
                            filterValue.toString() === "true" ? true : false
                        );
                    },
                    options: {
                        true: "Sim",
                        false: "Não",
                    },
                }),
            },
            {
                dataField: "NUM_PERCENTUAL_VALOR_PRINCIPAL",
                text: "Valor Principal (%)",
                filter: textFilter({
                    placeholder: "Filtro...",
                    onFilter: (filterValue) => {
                        setPercentualValorPrincipal(filterValue.toString());
                    },
                }),
            },
            {
                dataField: "",
                text: "",
                isDummyField: true,
                formatter: (c, row) => (
                    <div className="Button-Tools">
                        <button
                            type="button"
                            className="btn btn-primary font-weight-bold mr-2 w-100px"
                            disabled={excluirAlcadaDescontoLoading}
                            onClick={() => {
                                setShow(true);
                                setModal({
                                    headerComponent: "Desconto Alçada",
                                    IconHeader: faClipboardList,
                                    Component: () => (
                                        <CadastrarDescontoAlcada
                                            setShow={setShow}
                                            updateList={updateList}
                                            alcadasDesconto={row}
                                        />
                                    ),
                                    size: "lg",
                                });
                            }}
                        >
                            <FontAwesomeIcon icon={faEdit} size="lg" /> Editar
                        </button>

                        <button
                            type="button"
                            className="btn btn-danger font-weight-bold mr-2 w-100px"
                            disabled={excluirAlcadaDescontoLoading}
                            onClick={() => {
                                AlertConfirmation(
                                    "Exclusão de registro",
                                    "Tem certeza que deseja excluir essa Alçada de Desconto?"
                                ).then((result) => {
                                    if (result.isConfirmed) {
                                        excluirAlcadaDesconto(
                                            row.ID_ALCADA_DESCONTO
                                        ).then(() => {
                                            updateList();
                                        });
                                    }
                                });
                            }}
                        >
                            {excluirAlcadaDescontoLoading ? (
                                <>
                                    {" "}
                                    <Spinner size="sm" /> Excluir{" "}
                                </>
                            ) : (
                                <>
                                    {" "}
                                    <FontAwesomeIcon
                                        icon={faTrash}
                                        size="lg"
                                    />{" "}
                                    Excluir
                                </>
                            )}
                        </button>
                    </div>
                ),
            },
        ];

    return (
        <div>
            <div className="card card-custom">
                <div className="card-header card-header-tabs-line d-flex align-items-center">
                    <h3 className="card-title align-items-start ">
                        <span className="card-label font-weight-bolder text-dark gruposTitle">
                            Alçadas de Desconto Cobrança
                        </span>
                    </h3>
                    <div className="card-toolbar">
                        <button
                            type="button"
                            className="btn btn-success font-weight-bold mr-2"
                            onClick={() => {
                                setShow(true);
                                setModal({
                                    headerComponent: "Desconto Alçada",
                                    IconHeader: faClipboardList,
                                    Component: () => (
                                        <CadastrarDescontoAlcada
                                            setShow={setShow}
                                            updateList={updateList}
                                        />
                                    ),
                                    size: "lg",
                                });
                            }}
                        >
                            <FontAwesomeIcon icon={faPlus} size="lg" /> Nova
                            Alçada de Desconto
                        </button>
                    </div>
                </div>

                <Table
                    wrapperClasses="mw-100 custom-scroll p-4"
                    columns={tableviewColumns}
                    data={alcadasDesconto ?? []}
                    keyField="ID_ALCADA_DESCONTO"
                    loading={alcadasDescontoLoading}
                    noDataIndication={() => (
                        <div className="text-black-50 text-center">
                            Nenhum Formulário Encontrado
                        </div>
                    )}
                    defaultStyle={{
                        align: "center",
                        classes: "p-2",
                    }}
                    classes="v-middle-cells"
                    noHover
                    noSearch
                    filter={filterFactory()}
                    bordered={false}
                    striped={true}
                    rowClasses={"rowClasses"}
                    center={true}
                />
            </div>

            <ModalComponent
                ModalComponent={modal}
                show={show}
                setShow={setShow}
            />
        </div>
    );
}
